var modal = `
<div class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
  <div class="modal-dialog" role="document">
    <div class="modal-content text-center">
      <div class="modal-header">
        <h5 class="modal-title mx-auto">
          <img src="https://prod-pledgeling-com.s3.us-west-2.amazonaws.com/media/images/fundraiser_landing_pages/titos.png" style="-webkit-user-select: none; user-select: none; max-height: 10rem" />
        </h5>
      </div>
      <div class="modal-body">
        <p class="my-5 text-uppercase">
          <span id="copy-21">Are you 21 years old or older</span>?
        </p>
        <p class="mb-0">
          <small><a href="https://www.pledge.to/terms" target="_blank">Terms of Service,</a> <a href="https://www.pledge.to/privacy" target="_blank">Privacy Policy</a></small>
        </p>
      </div>
      <div class="modal-footer justify-content-center">
        <a href="https://www.responsibility.org/" class="btn btn-light">No</a>
        <button type="button" class="btn btn-primary" id="is-21">Yes</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show"></div>`


var widget = document.getElementById('donate')
var nav = document.getElementsByClassName("navbar")[0]
var mainSection = document.querySelector('body > .container')
var footer = document.getElementsByClassName("footer")[0]


footer.insertAdjacentHTML('afterBegin', `
  <img
    src="https://prod-pledgeling-com.s3.us-west-2.amazonaws.com/media/images/fundraiser_landing_pages/titos-footer-desktop.png"
    class="d-none d-md-block mb-3"
    style="max-height: 1.5rem"
  >
  <img
    src="https://prod-pledgeling-com.s3.us-west-2.amazonaws.com/media/images/fundraiser_landing_pages/titos-footer-mobile.png"
    class="d-md-none mb-3"
    style="max-width: 100%"
  >
`)

nav.classList.add('blur-21')
mainSection.classList.add('blur-21')
footer.classList.add('blur-21')

document.body.insertAdjacentHTML('beforeEnd', modal)

var storage   = localStorage
var key       = 'titos-flp-is-21'
var canDrink    = storage && parseInt(storage.getItem(key)) || 0

var modal     = document.querySelector('.modal.show')
var backdrop  = document.querySelector('.modal-backdrop.show')
var blurred   = document.querySelectorAll('.blur-21')

var closeModal = function closeModal (e, immediate) {
  document.body.classList.remove('modal-open')

  if (immediate) {
    blurred.forEach(function(el) {
      el.classList.remove('blur-21')
      el.classList.remove('clear-21')
    })
    modal.style.display = backdrop.style.display = 'none'
  } else {
    blurred.forEach(function(el) { el.classList.add('clear-21') })
    modal.classList.remove('show')
    backdrop.classList.remove('show')
    setTimeout(function() { closeModal(e, true) }, 550 )
  }

  if (!canDrink && storage)
    storage.setItem(key, canDrink = 1)
}

if (canDrink)
  closeModal(null, true)
else
  document.getElementById('is-21').addEventListener('click', closeModal)
